/** Shared display formatting for admin list pages (AuditLogPage,
 * CallLogPage) — kept in one place so the two don't drift on how a
 * timestamp reads. */
export function formatTimestamp(iso: string): string {
  return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}
